import { Button } from '@/components/ui/button';

export default function Partner() {
  const href =
    'mailto:support@vexi.co.za' +
    '?subject=' +
    encodeURIComponent('Vexi Partnership');

  return (
    <div className="min-h-screen bg-background">
      <main className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-heading font-bold text-foreground">
          Become a Partner
        </h1>

        <div className="mt-8 space-y-5 text-foreground/90 leading-relaxed">
          <p>Are you a store or brand?</p>

          <p>
            We’re building Vexi to help people find real prices in their area. If you’d like to
            collaborate, promote your store, or explore partnerships, we’d love to hear from you.
          </p>

          <div className="pt-2">
            <Button asChild className="rounded-full bg-primary hover:bg-primary/90">
              <a href={href}>Contact us</a>
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}

